import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import Button, { ButtonType } from '../../../Button'
import { SettingSectionButtons } from '../../SettingSectionButtons'
import { isSettingsFormSectionSaveAvailable } from '../SettingsFormSection.utils'

import * as styles from './SettingsFormSectionButtons.module.css'

function SettingsFormSectionButtons({
  children,
  saveIgnoredFieldNames = EMPTY_LIST,
}) {
  const { dirty, initialValues, isSubmitting, resetForm, values } =
    useFormikContext()

  const isSaveAvailable = isSettingsFormSectionSaveAvailable({
    initialValues,
    saveIgnoredFieldNames,
    values,
  })

  function handleReset() {
    resetForm()
  }

  return (
    <SettingSectionButtons
      ButtonReset={dirty ? Button.Text : null}
      className={styles.SettingsFormSectionButtons}
      resetProps={{ disabled: isSubmitting, onClick: handleReset }}
      saveProps={{
        disabled: !isSaveAvailable,
        isLoading: isSubmitting,
        type: ButtonType.Submit,
      }}
    >
      {children}
    </SettingSectionButtons>
  )
}

export default SettingsFormSectionButtons
